import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "minimal-profile" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = {
  id: "projects",
  class: "section section-alt"
}
const _hoisted_4 = { class: "container fade-up" }
const _hoisted_5 = { class: "projects-grid" }
const _hoisted_6 = { class: "project-meta" }
const _hoisted_7 = { class: "project-number" }
const _hoisted_8 = { class: "project-role" }
const _hoisted_9 = { class: "project-title" }
const _hoisted_10 = { class: "project-desc" }
const _hoisted_11 = { class: "tech-tags" }
const _hoisted_12 = {
  id: "skills",
  class: "section"
}
const _hoisted_13 = { class: "container fade-up" }
const _hoisted_14 = { class: "skills-grid" }
const _hoisted_15 = { class: "skill-group-title" }
const _hoisted_16 = { class: "skill-list" }
const _hoisted_17 = { class: "footer" }
const _hoisted_18 = { class: "container footer-container" }

import { ref, onMounted, onUnmounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const isScrolled = ref(false);

const handleScroll = () => {
  isScrolled.value = window.scrollY > 50;
};

onMounted(() => {
  window.addEventListener('scroll', handleScroll);
  
  // Setup intersection observer for fade-up animations
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -50px 0px'
  });

  document.querySelectorAll('.fade-up').forEach((el) => {
    observer.observe(el);
  });
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

const projects = [
  {
    title: 'Sistema de pesaje inteligente para camiones',
    role: 'Arquitecto de software y líder técnico',
    desc: 'Sistema modular para básculas de camiones: conexión con indicadores de peso, detección de ejes, control de tránsito, ticketing automático, OCR de patentes, integración de hardware y software con lógica de negocio compleja.',
    tags: ['VB.NET', 'SQL Server', 'TCP', 'Electron', 'Vue']
  },
  {
    title: 'Framework de auditoría visual con IA local',
    role: 'CTO externo y desarrollador principal',
    desc: 'Sistema para captura, OCR local con LLM, persistencia de auditorías, y visualización. Incluye selección de ROI por cámara, logging detallado y endpoints REST.',
    tags: ['Flask', 'SQLite', 'Ollama Vision', 'OpenCV', 'API REST']
  },
  {
    title: 'Core distribuido para control de dispositivos',
    role: 'Arquitecto principal',
    desc: 'Arquitectura para gestión de dispositivos sensorizados con paneles modulares, normalización de datos, reglas de automatización, y microservicios de extracción/inyección por protocolo.',
    tags: ['Electron', 'Vue 3', 'Node.js', 'Go', 'TimescaleDB']
  },
  {
    title: 'Monitorización meteorológica distribuida',
    role: 'Arquitecto de software y líder técnico',
    desc: 'Sistema completo de monitorización para estaciones meteorológicas con múltiples sensores, comunicaciones heterogéneas y procesamiento en tiempo real.',
    tags: ['Go', 'Kafka', 'Kubernetes', 'Vue 3', 'TimescaleDB']
  },
  {
    title: 'Ecosistema de envíos multi-canal',
    role: 'Líder técnico y arquitecto principal',
    desc: 'Plataforma integral de gestión logística con cientos de integraciones: marketplaces, operadores logísticos, gestión de envíos, pedidos, tickets, fulfillment.',
    tags: ['Node.js', 'React', 'PostgreSQL', 'Kubernetes', 'Event Sourcing']
  },
  {
    title: 'Sistema integral para clínicas veterinarias',
    role: 'Desarrollador principal y arquitecto',
    desc: 'Sistema completo de gestión clínica veterinaria con historia médica digital, agenda inteligente, facturación, inventario, firmas digitales y sincronización offline.',
    tags: ['Vue 3', 'Go', 'TypeScript', 'PWA', 'PostgreSQL']
  }
];

const skills = [
  {
    title: 'Arquitectura y Backend',
    items: [
      'Diseño de sistemas escalables y resilientes',
      'Clean Architecture, DDD, Microservicios',
      'C#, VB.NET, Go, Python, Node.js',
      'SQL Server, PostgreSQL, TimescaleDB, NoSql',
      'Docker, Kubernetes, CI/CD'
    ]
  },
  {
    title: 'Frontend',
    items: [
      'Vue 2 / Vue 3, React, Nuxt, TypeScript',
      'Electron, SPA, PWA',
      'HTML, CSS, JavaScript vanilla',
      'Vuetify, Pinia, Tailwind'
    ]
  },
  {
    title: 'Inteligencia Artificial',
    items: [
      'Computer Vision con OpenCV y YOLOv8',
      'Procesamiento de imágenes, ROI dinámico',
      'LLMs offline y locales',
      'Sistemas de control basados en workflows'
    ]
  },
  {
    title: 'Sistemas de Agentes IA',
    items: [
      'Arquitectura de agentes distribuidos',
      'Orquestación de workflows complejos con IA',
      'Coordinación entre agentes autónomos',
      'Escalabilidad horizontal de agentes'
    ]
  },
  {
    title: 'Eventos y Mensajería',
    items: [
      'Apache Kafka, RabbitMQ, Redis Pub/Sub',
      'Event Sourcing y CQRS',
      'Arquitecturas basadas en eventos'
    ]
  },
  {
    title: 'Protocolos y Comunicación',
    items: [
      'TCP, Serial (RS232/RS485), WebSocket, MQTT',
      'Comunicación entre hardware/software',
      'Manejo de drivers físicos y virtuales'
    ]
  }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", {
      class: _normalizeClass(["navbar", { 'scrolled': isScrolled.value }])
    }, [...(_cache[0] || (_cache[0] = [
      _createStaticVNode("<div class=\"nav-content\" data-v-2848999f><div class=\"nav-brand text-gradient-inverted\" data-v-2848999f>GHdev</div><div class=\"nav-links hidden-mobile\" data-v-2848999f><a href=\"#about\" data-v-2848999f>Sobre mi</a><a href=\"#projects\" data-v-2848999f>Proyectos</a><a href=\"#skills\" data-v-2848999f>Skills</a><a href=\"#contact\" data-v-2848999f>Contacto</a></div><a href=\"#contact\" class=\"text-link hidden-mobile\" data-v-2848999f>Hablemos ↗</a></div>", 1)
    ]))], 2),
    _createElementVNode("main", _hoisted_2, [
      _cache[3] || (_cache[3] = _createStaticVNode("<section id=\"hero\" class=\"section hero\" data-v-2848999f><div class=\"container hero-container fade-up\" data-v-2848999f><h1 class=\"hero-title\" data-v-2848999f> Arquitecto de software y <br data-v-2848999f><span class=\"text-gradient\" data-v-2848999f>soluciones tecnológicas</span></h1><p class=\"hero-desc\" data-v-2848999f> Diseño sistemas complejos con propósito: resolver desafíos reales del negocio. Conecto arquitectura de software, inteligencia artificial y estrategia para crear soluciones robustas, escalables y con impacto. </p><div class=\"hero-actions\" data-v-2848999f><a href=\"#projects\" class=\"text-link text-link-primary\" data-v-2848999f>Ver Proyectos ↓</a><a href=\"#contact\" class=\"text-link\" data-v-2848999f>Contactar ↗</a></div></div></section><section id=\"about\" class=\"section\" data-v-2848999f><div class=\"container fade-up\" data-v-2848999f><h2 class=\"section-title\" data-v-2848999f>Sobre mi</h2><div class=\"about-grid\" data-v-2848999f><div class=\"about-text\" data-v-2848999f><p data-v-2848999f>Soy arquitecto de software senior con más de 10 años de experiencia diseñando e implementando soluciones robustas en múltiples sectores.</p><p data-v-2848999f>A lo largo de mi carrera he comprendido que la tecnología por sí sola no basta: debe responder a problemas concretos, con impacto real en el negocio.</p><blockquote class=\"about-quote\" data-v-2848999f> &quot;Desarrollo soluciones del presente con tecnologías del futuro. Transformo desafíos técnicos en oportunidades de negocio.&quot; </blockquote></div><div class=\"about-cards\" data-v-2848999f><div class=\"feature-card\" data-v-2848999f><h3 data-v-2848999f>Arquitectura avanzada</h3><p data-v-2848999f>Sistemas distribuidos, resilientes y escalables (Clean Architecture, DDD, microservicios).</p></div><div class=\"feature-card\" data-v-2848999f><h3 data-v-2848999f>Inteligencia Artificial</h3><p data-v-2848999f>Visión computacional, LLMs y modelos de aprendizaje profundo para el mundo real.</p></div><div class=\"feature-card\" data-v-2848999f><h3 data-v-2848999f>Consultoría estratégica</h3><p data-v-2848999f>Auditorías técnicas, análisis de procesos e identificación de cuellos de botella.</p></div></div></div></div></section>", 2)),
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "section-title" }, "Proyectos destacados", -1)),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(projects, (project, index) => {
              return _createElementVNode("article", {
                class: "project-card",
                key: index
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(String(index + 1).padStart(2, '0')), 1),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(project.role), 1)
                ]),
                _createElementVNode("h3", _hoisted_9, _toDisplayString(project.title), 1),
                _createElementVNode("p", _hoisted_10, _toDisplayString(project.desc), 1),
                _createElementVNode("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(project.tags, (tag) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "tag",
                      key: tag
                    }, _toDisplayString(tag), 1))
                  }), 128))
                ])
              ])
            }), 64))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _cache[2] || (_cache[2] = _createElementVNode("h2", { class: "section-title" }, "Habilidades técnicas", -1)),
          _createElementVNode("div", _hoisted_14, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(skills, (skillGroup, index) => {
              return _createElementVNode("div", {
                class: "skill-group",
                key: index
              }, [
                _createElementVNode("h3", _hoisted_15, _toDisplayString(skillGroup.title), 1),
                _createElementVNode("ul", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skillGroup.items, (item, i) => {
                    return (_openBlock(), _createElementBlock("li", { key: i }, _toDisplayString(item), 1))
                  }), 128))
                ])
              ])
            }), 64))
          ])
        ])
      ]),
      _cache[4] || (_cache[4] = _createStaticVNode("<section id=\"contact\" class=\"section section-alt\" data-v-2848999f><div class=\"container fade-up text-center contact-container\" data-v-2848999f><h2 class=\"section-title\" data-v-2848999f>Contacto</h2><p class=\"contact-desc\" data-v-2848999f> Estoy abierto a colaborar en proyectos que requieran visión, experiencia y profundidad técnica. <br data-v-2848999f>¿Tienes una idea, sistema o desafío en marcha? </p><div class=\"contact-actions\" data-v-2848999f><a href=\"mailto:hola@gonzalohonorato.cl\" class=\"email-link\" data-v-2848999f>hola@gonzalohonorato.cl</a><span class=\"location-tag\" data-v-2848999f><svg width=\"16\" height=\"16\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-2848999f><path d=\"M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z\" data-v-2848999f></path><circle cx=\"12\" cy=\"10\" r=\"3\" data-v-2848999f></circle></svg> Santiago, Chile </span></div></div></section>", 1))
    ]),
    _createElementVNode("footer", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("p", null, "© " + _toDisplayString(new Date().getFullYear()) + " Gonzalo Honorato.", 1),
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "footer-design" }, "Designed & Built with elegance.", -1))
      ])
    ])
  ]))
}
}

})